const ALLOWED_PROTOCOLS = ['http:', 'https:']

/**
 * True when `url` resolves to an http(s) URL. Relative URLs resolve against
 * the current page; `javascript:`, `data:` etc. are rejected.
 */
export const isSafeExternalUrl = (url: string | null | undefined): boolean => {
  if (!url) {
    return false
  }

  try {
    return ALLOWED_PROTOCOLS.includes(
      new URL(url, window.location.href).protocol
    )
  } catch {
    return false
  }
}

/**
 * `window.open` in a new tab, but only for http(s) URLs. Defaults to
 * `noopener` so the opened page can't navigate this tab via `window.opener`.
 */
export const openExternalUrl = (
  url: string | null | undefined,
  features = 'noopener'
): Window | null => {
  if (!url || !isSafeExternalUrl(url)) {
    return null
  }

  return window.open(url, '_blank', features)
}
